<template>
  <div>
    <button
      class="button is-primary is-pulled-right"
      @click="show"
    >
      <Loader :is-loading="isRequesting" />
      Edit
    </button>
    <simple-modal
      :active="isActive"
      title="Edit"
      action-label="Save"
      @action="updateNameRequest"
      @close="close"
    >
      <Field
        v-model="jobName"
        label="Title"
        :validate="true"
      />
    </simple-modal>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import Field from '../Simulation/Field.vue';
import Loader from '../Loader.vue';

export default {
  components: {
    Field,
    Loader,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
  },
  emits: ['jobNameEdit'],
  data() {
    return {
      isActive: false,
      isRequesting: false,
      jobName: { value: '', ok: false, checks: 0 }, // for editing by user
    };
  },
  methods: {
    show() {
      this.jobName = { value: this.name, ok: true, checks: 0 };
      this.isActive = true;
    },
    close() {
      this.jobName = { value: this.name, ok: true, checks: 0 };
      this.isActive = false;
    },
    async updateNameRequest() {
      const newName = this.jobName.value;
      this.close();
      this.isRequesting = true;
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
          mutation editJob($product_name: ProductName!, $job_id: ID!, $job_name: String!) {
            job: editJob(product_name: $product_name, job_id: $job_id, job_name: $job_name) {
              name
            }
          }`,
          variables: {
            product_name: this.$product.id,
            job_id: this.$route.params.id,
            job_name: newName,
          },
        });
        this.$emit('jobNameEdit', response.data.job.name);
      } catch (error) {
        console.error('error', error);
      }
      this.isRequesting = false;
    },
  },
};
</script>
